import { render, staticRenderFns } from "./DarkMode.vue?vue&type=template&id=c8ef5338&scoped=true&"
import script from "./DarkMode.vue?vue&type=script&lang=js&"
export * from "./DarkMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ef5338",
  null
  
)

export default component.exports